import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-search-landing-page',
  standalone: false,
  templateUrl: './admin-search-landing-page.component.html',
  styleUrl: './admin-search-landing-page.component.scss'
})
export class AdminSearchLandingPageComponent {
  public searchResults:any;
  public onPageChange:any;
  public isAirmenAgentSearch: boolean;
  public sortOrder:string;
  public onOperatorEdit : boolean;
  public columns : any[];
  public resetPagination:boolean;
  
  handleSearch(event:any){
    this.searchResults = event;
  }

  handlePageChange(event:any){
  this.onPageChange= event;
  }

  sortOrderForSearch(event:any){
    this.sortOrder=event;
  }

  IsSearchTypeAirmen(event:boolean)
  {
    this.isAirmenAgentSearch = event;
    if(!this.isAirmenAgentSearch){
      this.columns = [{ field: 'arOwnerName', displayName: 'Aircraft Owner Name', isSortable: true },
        { field: 'nNumber', displayName: 'N Number', isSortable: false},
        { field: 'serialNo', displayName: 'Serial Number', isSortable: false},
      ];
    }else{
      this.columns = [{ field: 'operatorFirstName', displayName: 'Airman / Operator', isSortable: true },
        { field: 'operatorEmail', displayName: 'Airman / Operator Email', isSortable: false},
        { field: 'operatorFTN', displayName: 'FTN', isSortable: false},
        { field: 'operatorDob', displayName: 'DOB', isSortable: false},
      ];
    }
  }

  refreshOnOperatorEdit(event:any){
    this.onOperatorEdit=event;
  }
  handleResetPagination(event:boolean){
    this.resetPagination =event;
  }
}
